export default "__VITE_ASSET__6d782546__"